import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, Tooltip, Typography } from 'antd';
import { createStyles } from 'antd-style';
import { FormItemProps as BaseFormItemProps } from 'antd/lib/form';
import clsx from 'clsx';
import React from 'react';

const useStyles = createStyles(({ css }) => ({
  formItem: css`
    & > .ant-row > .ant-col > .ant-form-item-additional {
      display: none !important;
    }
  `,
  errorContainer: css`
    position: relative;
    min-height: 20px; /* Đảm bảo chiều cao tối thiểu để tránh thay đổi layout */
  `,
  errorText: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    color: #f5222d;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
}));

interface FormItemProps extends BaseFormItemProps {
  isTable?: boolean;
  renderInput?: (errors: string[]) => React.ReactNode;
  iconInfoStyles?: React.CSSProperties;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

const FormItem: React.FC<FormItemProps> = ({
  label,
  name,
  children,
  renderInput,
  className,
  iconInfoStyles,
  placement = 'top',
  isTable,
  ...props
}) => {
  const { styles } = useStyles();

  return (
    <Form.Item shouldUpdate noStyle>
      {({ getFieldError }) => {
        const errors = name ? getFieldError(name) : [];
        const errorMessage = errors?.length > 0 ? errors[0] : '';

        // Base error icon styles
        const baseIconStyle: React.CSSProperties = {
          color: '#f5222d',
          position: 'absolute',
          top: label ? '75%' : '50%',
          transform: 'translateY(-50%)',
          right: '12px',
          zIndex: 1,
          backgroundColor: 'white',
          ...iconInfoStyles,
        };

        return (
          <div style={{ position: 'relative' }}>
            <Form.Item
              className={clsx(className, { ['point-mb-0']: isTable, [styles.formItem]: !name })}
              label={label}
              name={name}
              validateFirst
              {...props}
              help={
                !isTable ? (
                  <div className={styles.errorContainer}>
                    {errorMessage && (
                      <Typography.Text type="danger" className={styles.errorText} ellipsis={{ tooltip: errorMessage }}>
                        {errorMessage}
                      </Typography.Text>
                    )}
                  </div>
                ) : (
                  false
                )
              }
              validateStatus={errorMessage ? 'error' : undefined}
            >
              {renderInput ? renderInput(errors) : children}
            </Form.Item>

            {!!errors?.length && isTable && (
              <Tooltip placement={placement} title={errorMessage} open={!!errorMessage}>
                <InfoCircleOutlined style={baseIconStyle} />
              </Tooltip>
            )}
          </div>
        );
      }}
    </Form.Item>
  );
};

export default FormItem;
